import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { FixturesRoutingModule } from './fixtures-routing.module';
import { FixturesComponent } from './fixtures/fixtures.component';
import { MomentModule } from 'ngx-moment';
import { FixturesNewComponent } from './fixtures-new/fixtures-new.component';
import { NgAddToCalendarModule } from '@trademe/ng-add-to-calendar';


@NgModule({
  declarations: [FixturesComponent, FixturesNewComponent],
  imports: [
    CommonModule,
    SlickCarouselModule,
    NgAddToCalendarModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    FixturesRoutingModule,
    MomentModule
  ]
})
export class FixturesModule { }
